import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoDnkCollapsed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6154 34.1282V19.7124L12.6216 22.9991L16.4368 31.9024L21.6154 34.1282Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.724 34.1282L22.7184 19.7124L31.716 22.9991L27.9026 31.9024L22.724 34.1282Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6271 20.3523L21.6154 18.529V17.4346H16.6271V20.3523Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.7123 20.3523L22.7184 18.5271V17.4346H27.7123V20.3523Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6038 14.0959H17.7356V16.3217H26.6038V14.0959Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9526 12.983C19.9526 12.6907 20.01 12.4013 20.1214 12.1312C20.2328 11.8612 20.3961 11.6158 20.602 11.4091C20.8079 11.2024 21.0523 11.0385 21.3213 10.9266C21.5902 10.8148 21.8785 10.7572 22.1697 10.7572C22.4608 10.7572 22.7491 10.8148 23.0181 10.9266C23.2871 11.0385 23.5315 11.2024 23.7374 11.4091C23.9433 11.6158 24.1066 11.8612 24.218 12.1312C24.3294 12.4013 24.3867 12.6907 24.3867 12.983H19.9526Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.3352 8.91351L36.9704 11.2877C39.5903 14.6248 41.015 18.7501 41.015 22.9992C41.015 27.2482 39.5903 31.3735 36.9704 34.7106L39.3352 37.0848C42.5715 33.1095 44.3394 28.1333 44.3394 22.9992C44.3394 17.865 42.5715 12.8888 39.3352 8.91351Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5043 8.14005C13.8283 5.50981 17.9374 4.07949 22.1697 4.07949C26.402 4.07949 30.5111 5.50981 33.8351 8.14005L36.1999 5.76585C32.2403 2.51682 27.2836 0.741943 22.1697 0.741943C17.0558 0.741943 12.0991 2.51682 8.13943 5.76585L10.5043 8.14005Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.8351 37.8583C30.5111 40.4885 26.402 41.9188 22.1697 41.9188C17.9374 41.9188 13.8283 40.4885 10.5043 37.8583L8.13943 40.2325C12.0991 43.4815 17.0558 45.2564 22.1697 45.2564C27.2836 45.2564 32.2403 43.4815 36.1999 40.2325L33.8351 37.8583Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.36901 34.7106C4.74912 31.3735 3.32442 27.2482 3.32442 22.9992C3.32442 18.7501 4.74912 14.6248 7.36901 11.2877L5.00416 8.91351C1.76789 12.8888 0 17.865 0 22.9992C0 28.1333 1.76789 33.1095 5.00416 37.0848L7.36901 34.7106Z",
			fill: "white"
		})
	]
});
export default SvgLogoDnkCollapsed;
